import {MenuOpenOutlined} from '@mui/icons-material';
import {IconButton} from '@mui/material';

type MenuOpenButtonProps = {
    handleOpenClick: () => void;
    isOpen: boolean;
};

export const MenuOpenButton = ({handleOpenClick, isOpen}: MenuOpenButtonProps) => {
    return (
        <IconButton
            onClick={handleOpenClick}
            color='primary'
            size='small'
            sx={{
                alignSelf: 'flex-end',
                margin: '0 8px',
                border: '1px solid rgba(var(--mui-palette-primary-mainChannel) / 0.5)',
                borderRadius: '4px',
            }}
        >
            <MenuOpenOutlined
                sx={{
                    transition: '.5s ease-in-out',
                    transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
                }}
            />
        </IconButton>
    );
};
